/* (ignored) */


//////////////////
// WEBPACK FOOTER
// stream (ignored)
// module id = 6
// module chunks = 1